import styled from 'styled-components';
import { getImageUrl } from 'utils';
import { heavy, normal } from '../../styles/fonts';

const ErrorIcon = styled.div`
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${getImageUrl('/icons/ic-error-filled.svg')};
  margin-right: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  ${normal};
  ${heavy};
`;

const SuccessIcon = styled.div`
  width: 5rem;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${getImageUrl('/icons/ic-success-filled.svg')};
  margin-right: 16px;
`;

const InfoIcon = styled.div`
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${getImageUrl('/icons/ic-direct-call-filled.svg')};
  margin-right: 16px;
`;

const Message = styled.span`
  color: ${(props) => (props.color ? props.color : '#222222')};
`;

export const ErrorMessage = ({ message }: { message: string }) => {
  return (
    <Wrapper>
      <ErrorIcon /> <Message color="white">{message}</Message>
    </Wrapper>
  );
};

export const SuccessMessage = ({ message }: { message: string }) => {
  return (
    <Wrapper>
      <SuccessIcon /> <Message>{message}</Message>
    </Wrapper>
  );
};

export const InfoMessage = ({ message }: { message: string }) => {
  return (
    <Wrapper>
      <InfoIcon /> <Message>{message}</Message>
    </Wrapper>
  );
};
